<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row ">
<!--                <div class="col-12 col-sm-6 col-md-3">-->
<!--                    <div class="info-box">-->
<!--                        <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->

<!--                        <div class="info-box-content">-->
<!--                            <span class="info-box-text">CPU Traffic</span>-->
<!--                            <span class="info-box-number">-->
<!--                            10-->
<!--                            <small>%</small>-->
<!--                            </span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash; /.info-box-content &ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash; /.info-box &ndash;&gt;-->
<!--                </div>-->
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-danger elevation-1"><i class="fas fa-shopping-cart"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text"> Заказов за сегодня</span>
                            <span class="info-box-number">{{home.daycount}}</span>
                            <span class="info-box-number">{{home.sale_day}}</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->

                <!-- fix for small devices only -->
                <div class="clearfix hidden-md-up"></div>

                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-success elevation-1"><i class="fas fa-shopping-cart"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Заказов на завтра </span>
                            <span class="info-box-number">{{home.daycountfut}}</span>
                            <span class="info-box-number">{{home.sale_dayfut}}</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-shopping-cart"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Заказов на послезавтра </span>
                            <span class="info-box-number">{{home.daycountfut2}}</span>
                            <span class="info-box-number">{{home.sale_dayfut2}}</span>
                        </div>
                    <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
            <!-- /.col -->
            </div>
            <!-- /.row -->

            <div class="row">
                <!-- Left col -->
<!--                <div class="col-md-4">-->
<!--                    &lt;!&ndash; MAP & BOX PANE &ndash;&gt;-->
<!--                    <div class="card">-->
<!--                    <div class="card-header">-->
<!--                        <h3 class="card-title">Продажи по месяцам</h3>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; /.card-header &ndash;&gt;-->
<!--                    <div class="card-body p-0">-->
<!--                        <div class="table-responsive">-->

<!--                        </div>-->
<!--                    </div>-->
<!--                &lt;!&ndash; /.card-body &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.card &ndash;&gt;-->
<!--                &lt;!&ndash; /.card &ndash;&gt;-->
<!--            </div>-->
<!--                <div class="col-md-4">-->
<!--                    &lt;!&ndash; MAP & BOX PANE &ndash;&gt;-->
<!--                    <div class="card">-->
<!--                    <div class="card-header">-->
<!--                        <h3 class="card-title">Выручка за текущий месяц</h3>-->

<!--&lt;!&ndash;                        <div class="card-tools">&ndash;&gt;-->
<!--&lt;!&ndash;                        <button type="button" class="btn btn-tool" data-card-widget="collapse">&ndash;&gt;-->
<!--&lt;!&ndash;                            <i class="fas fa-minus"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                        </button>&ndash;&gt;-->
<!--&lt;!&ndash;                        <button type="button" class="btn btn-tool" data-card-widget="remove">&ndash;&gt;-->
<!--&lt;!&ndash;                            <i class="fas fa-times"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                        </button>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash; /.card-header &ndash;&gt;-->
<!--                    <div class="card-body p-0">-->
<!--                        <div class="table-responsive">-->

<!--                        </div>-->
<!--                    </div>-->
<!--                &lt;!&ndash; /.card-body &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.card &ndash;&gt;-->
<!--                &lt;!&ndash; /.card &ndash;&gt;-->
<!--            </div>-->
<!--                <div class="col-md-4">-->
<!--                    &lt;!&ndash; MAP & BOX PANE &ndash;&gt;-->
<!--                    <div class="card">-->
<!--                    <div class="card-header">-->
<!--                        <h3 class="card-title">Популярные позиции-->
<!--                        </h3>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; /.card-header &ndash;&gt;-->
<!--                    <div class="card-body p-0">-->
<!--                        <div class="table-responsive">-->

<!--                        </div>-->
<!--                    </div>-->
<!--                &lt;!&ndash; /.card-body &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.card &ndash;&gt;-->
<!--                &lt;!&ndash; /.card &ndash;&gt;-->
<!--            </div>-->


                <div class="col-md-4">
                    <!-- MAP & BOX PANE -->
                    <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Продажи
                        </h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            &ensp; Заказов за сегодня <font style="color: #064cd6">{{home.daycount}}</font> шт на <font style="color: #b43cc4">{{home.sale_day}}</font> руб.<br>
                            &ensp; Заказов на завтра <font style="color: #064cd6">{{home.daycountfut}}</font> шт на <font style="color: #b43cc4">{{home.sale_dayfut}}</font> руб.<br>
                            &ensp; Заказов на послезавтра <font style="color: #064cd6">{{home.daycountfut2}}</font> шт на <font style="color: #b43cc4">{{home.sale_dayfut2}}</font> руб.<br>
                            &ensp; Заказов за неделю <font style="color: #064cd6">{{home.weekcount}}</font> шт на <font style="color: #b43cc4">{{home.sale_week}}</font> руб.<br>
                            <br>
                            &ensp; Заказов от магазинов <font style="color: #064cd6">{{home.mounthcountus}}</font> шт на <font style="color: #b43cc4">{{home.sale_mounth_user}}</font> руб.<br>
                            &ensp; Заказов от клиентов <font style="color: #064cd6">{{home.mounthcountfil}}</font> шт на <font style="color: #b43cc4">{{home.sale_mounth_fil}}</font> руб.<br>
                            &ensp; Заказов за месяц <font style="color: #064cd6">{{home.mounthcount}}</font> шт на <font style="color: #b43cc4">{{home.sale_mounth}}</font> руб.<br>
                            <br>
                            &ensp; За прошлый месяц <font style="color: #064cd6">{{home.prewmounthcount}}</font> шт на <font style="color: #b43cc4">{{home.prewmounthcount}}</font> руб.<br>
                            <br>
                            &ensp; Средний чек за день<font style="color: #064cd6"> {{Math.round(home.medium_day)}}</font> руб.<br>

                        </div>
                    </div>
                <!-- /.card-body -->
                </div>
                <!-- /.card -->
                <!-- /.card -->
            </div>
            <!-- /.col -->

<!--            <div class="col-md-4">-->
<!--                &lt;!&ndash; Info Boxes Style 2 &ndash;&gt;-->
<!--                <div class="info-box mb-3 bg-secondary">-->
<!--                <span class="info-box-icon"><i class="fas fa-tag"></i></span>-->

<!--                <div class="info-box-content">-->
<!--                    <span class="info-box-text">Inventory</span>-->
<!--                    <span class="info-box-number">5,200</span>-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box-content &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box &ndash;&gt;-->
<!--                <div class="info-box mb-3 bg-success">-->
<!--                <span class="info-box-icon"><i class="far fa-heart"></i></span>-->

<!--                <div class="info-box-content">-->
<!--                    <span class="info-box-text">Mentions</span>-->
<!--                    <span class="info-box-number">92,050</span>-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box-content &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box &ndash;&gt;-->
<!--                <div class="info-box mb-3 bg-danger">-->
<!--                <span class="info-box-icon"><i class="fas fa-cloud-download-alt"></i></span>-->

<!--                <div class="info-box-content">-->
<!--                    <span class="info-box-text">Downloads</span>-->
<!--                    <span class="info-box-number">114,381</span>-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box-content &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box &ndash;&gt;-->
<!--                <div class="info-box mb-3 bg-info">-->
<!--                <span class="info-box-icon"><i class="far fa-comment"></i></span>-->

<!--                <div class="info-box-content">-->
<!--                    <span class="info-box-text">Direct Messages</span>-->
<!--                    <span class="info-box-number">163,921</span>-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box-content &ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash; /.info-box &ndash;&gt;-->
<!--            </div>-->
            <!-- /.col -->
            </div>
            <!-- /.row -->
        </div><!--/. container-fluid -->
    </section>
</template>

<script>
    export default {
        data() {
            return {
                home: {},
                form: new Form({
                    id: '',
                    name: '',
                })
            }
        },
        methods: {
            loadData() {
                // if(this.$gate.isAdmin()){
                axios.get("api/loadhome").then(({data}) => (this.home = data.data));
                console.log(123 );
                console.log(this.home );
                // }
            },
        },
        mounted() {

        },
        created() {
            this.loadData();
        }
    }



    // function drawChart() {
    //     var data = google.visualization.arrayToDataTable(home.countmoutday);
    //     var options = {
    //         /*'title': 'Продажи',*/
    //         'width': 370,
    //         'height': 300
    //     };
    //     var chart = new google.visualization.LineChart(document.getElementById('linechart'));
    //     chart.draw(data, options);
   // }

</script>


